import { Injectable } from '@angular/core';
import { DataService } from "../../../../Autofacets-Core/src/app/services/data.service";
import { GenericResponse } from "../../../../Autofacets-Core/src/app/business-entities/generic-response.class";
import { CustomerListRequestModel } from "../business-entities/customerList-request-model";
import { Urls } from "../../../../Autofacets-Core/src/app/utils/urls";

@Injectable({
  providedIn: 'root'
})
export class AccountDataService {

  constructor(private dataProvider: DataService) { }

  async getAccountList(requestModel: CustomerListRequestModel): Promise<GenericResponse<any>> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.GetAccountsList, requestModel).toPromise();
  }

  async getAccountDetailsById(id: string): Promise<GenericResponse<any>> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetAccountDetailsById, id).toPromise();
  }

  async getContactDetailsById(id: string, startRecordNumber: number, numberOfRecord: number): Promise<GenericResponse<any>> {
    return this.dataProvider.Get<GenericResponse<any>>(Urls.GetContactDetailsById, id, startRecordNumber, numberOfRecord).toPromise();
  }
}
